function NotFound() {
  return <h2 className="bg-warning p-2 m-2 text-white text-center">Не знайдено</h2>;
}

export default NotFound;
